import { useEffect, useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ivrIcon from "../../images/chatbot.png";
import { Stack } from "react-bootstrap";
import { useSelector } from "react-redux";
/*El componente IVRList muestra una lista de IVRs y permite al usuario seleccionar uno mediante un radio button. La lista de IVRs se obtiene de un servidor remoto 
dependiendo del modelo del PBX (P-Series o S-Series). 
El componente gestiona los datos de los IVRs y el índice del IVR seleccionado, y notifica el IVR seleccionado a través de los callbacks setIvrSelected y setIvrSelectedName.
setIvrSelected (prop): Función que recibe el número del IVR seleccionado.
setIvrSelectedName (prop): Función que recibe el nombre del IVR seleccionado.
number (prop): Número del IVR preseleccionado, si existe.
ivrs (state): Lista de IVRs obtenida desde el servidor.
ivrList (state): Lista filtrada de IVRs.
indexChecked (state): Índice del IVR seleccionado.
numberGet (ref): Valor de number usado para la selección inicial.
pbx (selector): Información del PBX (dominio, token, modelo) obtenida del estado global.
handleRadioChange (callback): Función que maneja la selección de un IVR.s 
*/
function IVRList({ setIvrSelected, setIvrSelectedName, number }) {
  const [ivrs, setIvrs] = useState(null);
  const [ivrList, setIvrList] = useState([]);
  const [indexChecked, setIndexChecked] = useState();
  const numberGet = useRef(number);
  const pbx = useSelector((state) => state.pbx.value);
  useEffect(() => {
    numberGet.current = number;
  }, [number]);
  // Efecto para cargar datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        let api =
          pbx.domain + "/openapi/v1.0/ivr/list?access_token=" + pbx.token;
        if (pbx.model === "S-Series") {
          api = pbx.domain + "/api/v2.0.0/ivr/query?token=" + pbx.token;
          const result = await axios.post(api, { number: "all" });
          if (result.data.status === "Success") {
            setIvrs(result.data.ivr);
          }
        } else {
          const result = await axios.get(api);
          if (result.data.errmsg === "SUCCESS") {
            setIvrs(result.data.data);
          }
        }
      } catch (error) {
        console.error("Hubo un error:", error.message);
      }
    };

    fetchData();
  }, [pbx]);

  // Efecto para configurar ivrList y seleccionar el índice
  // useEffect(() => {
  //   console.log(indexChecked);
  //   if (ivrs) {
  //     setIvrList(ivrs);
  //     const index = ivrs.findIndex(
  //       (item) =>
  //         item.number === numberGet.current?.toString() ||
  //         item.number === numberGet.current?.toString()
  //     );
  //     if (index !== -1 && number) {
  //       setIndexChecked(index);
  //     }
  //   }
  //   console.log(indexChecked);
  // }, [ivrs, pbx.model]);

  // Efecto para configurar ivrList y seleccionar el índice
  useEffect(() => {
    if (ivrs && ivrs.length > 0) {
      setIvrList(ivrs);

      // Buscar el índice del IVR que coincide con el número proporcionado
      const index = ivrs.findIndex(item =>
        item.number.toString() === numberGet.current?.toString()
      );

      if (index !== -1) {
        setIndexChecked(index);
        // También actualizar los valores seleccionados
        setIvrSelected(ivrs[index].number);
        setIvrSelectedName(ivrs[index].name || ivrs[index].ivrname);
      }
    }
  }, [ivrs]); // Solo dependemos de ivrs

  const handleRadioChange = useCallback(
    (index, number, name) => {
      setIndexChecked(index);
      setIvrSelected(number);
      setIvrSelectedName(name);
    },
    [setIvrSelected, setIvrSelectedName]
  );

  return (
    <Stack
      direction="horizontal"
      style={{ overflowY: "auto", whiteSpace: "nowrap" }}
    >
      {ivrList &&
        ivrList.length > 0 &&
        ivrList.map((item, index) => (
          <label
            className="text-center ml-5 mb-0 mt-1"
            key={pbx.model === "P-Series" ? item.number : item.number}
          >
            <input
              type="radio"
              name="ivr"
              value={pbx.model === "P-Series" ? item.number : item.number}
              checked={indexChecked === index}
              onChange={() =>
                handleRadioChange(
                  index,
                  pbx.model === "P-Series" ? item.number : item.number,
                  pbx.model === "P-Series" ? item.name : item.ivrname
                )
              }
              required
            />
            <img
              src={ivrIcon}
              alt={pbx.model === "P-Series" ? item.name : item.ivrname}
            />
            <p>{item.name || item.ivrname}</p>
          </label>
        ))}
    </Stack>
  );
}
IVRList.propTypes = {
  setIvrSelected: PropTypes.func.isRequired,
  setIvrSelectedName: PropTypes.func.isRequired,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IVRList.defaultProps = {
  number: null,
};
export default IVRList;
